export const trumpfLocales = {
    pt_BR: "Brasil",
    bg_BG: "Bulgaria",
    en_CA: "Canada",
    en_CN: "China",
    de_DE: "Deutschland",
    es_ES: "España",
    fr_FR: "France",
    en_IN: "India",
    it_IT: "Italia",
    hu_HU: "Magyarország",
    nl_NL: "Nederland",
    pl_PL: "Polska",
    pt_PT: "Portugal",
    ro_RO: "România",
    de_CH: "Schweiz",
    en_SG: "Singapore",
    sk_SK: "Slovensko",
    fr_CH: "Suisse",
    en_SE: "Sverige",
    tr_TR: "Türkiye",
    en_GB: "United Kingdom",
    en_US: "United States",
    vi_VN: "Việt Nam",
    de_AT: "Österreich",
    cs_CZ: "Česko",
    ru_RU: "Россия",
    th_TH: "ไทย",
    zh_CN: "中国",
    zh_TW: "台灣",
    ja_JP: "日本",
    ko_KR: "한국"
};

export const countries = Object.keys(trumpfLocales)
    .map((locale) => locale.split("_")[1])
    .filter((country, index, self) => self.indexOf(country) === index);

export const languages = Object.keys(trumpfLocales)
    .map((locale) => locale.split("_")[0])
    .filter((lng, index, self) => self.indexOf(lng) === index);

export const locales = Object.keys(trumpfLocales).map((locale) => locale.replace("_", "-"));

export default trumpfLocales;
